import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ContentService } from '../../services/common/content.service';
import { PageStateService } from '../../services/onboarding/page-state.service';

@Injectable({
  providedIn: 'root',
})
export class LoginResolver implements Resolve<boolean> {
  constructor(private ps: PageStateService, private cs: ContentService) {}
  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    return this.ps.getPageTransitionsByStateId('1');
  }
}
